import { useContext } from 'react';
import './capPoints.style.scss';
import '../Tables/table.style.scss';
import { PdfContext } from 'utils/context';
import { v1 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { translatePacCategory } from '../../Settings/Utils/SharedFunctions';

const CapPoints = () => {
  const { t } = useTranslation();
  const { forecastCampaign, suggest, pac, pacHelps } = useContext(PdfContext);

  const fourPointCategories = [
    t('simulation.result.pac.categories.winterCereals'),
    t('simulation.result.pac.categories.springCereals'),
    t('simulation.result.pac.categories.rootCrops'),
    t('simulation.result.pac.categories.winterOilseeds'),
    t('simulation.result.pac.categories.springOilseeds'),
  ];

  const years = suggest?.years;
  let headers = [
    ...[
      t('simulation.common.campaign'),
      `${forecastCampaign.startYear} - ${forecastCampaign.endYear}`,
    ],
    ...Array(years.length - 1)
      .fill()
      .map((_, i) => `${i + forecastCampaign.startYear + 1}-${i + forecastCampaign.endYear + 1}`),
  ];
  const pacWithoutN1 = pac?.map((categoryPac) => ({
    ...categoryPac,
    data: categoryPac?.data?.slice(1),
  }));
  return (
    <article className="pdf-page">
      <div className="tableau_center">
        <h6 className="title_h6">{t('simulation.result.pdf.pac.aidTitle')}</h6>
        <p className="title_description">{t('simulation.result.pdf.pac.aidNote')}</p>
        <table className="table">
          <thead className="table_head">
            <tr className="table_tr">
              <th className="column_name" key="4points" scope="col">
                {t('simulation.result.pdf.pac.fourPoints')}
              </th>
              <th className="column_name" key="5points" scope="col">
                {t('simulation.result.pdf.pac.fivePoints')}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table_tr">
              {pacHelps.map((value) => {
                return (
                  <td className="value_table" key={v1()}>
                    {value}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
      <div className="tableau_center">
        <h6 className="title_h6">{t('simulation.result.common.pointsTitle')}</h6>
        <div className="ceiling_points">
          <div className="color four_points_color"></div>
          <span>{t('simulation.result.pdf.pac.ceiling')}</span>
        </div>
        <table className="table PAChelp cap-table" style={{ marginTop: '10px !important' }}>
          <thead className="table_head">
            <tr className="table_tr">
              {headers.map((header, i) => (
                <th key={i} scope="col" className="column_name">
                  <span>{header}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pacWithoutN1?.map((p) => {
              const translatedCategory = translatePacCategory(p?.categorie, t);
              let isFourPointCategorie = fourPointCategories.includes(translatedCategory);
              return (
                <tr className="table_tr" key={v1()}>
                  <td className="value_table cap-cell">
                    <div className="cap_category">
                      <span
                        className="text-left"
                        style={{ marginLeft: isFourPointCategorie ? '12px' : 0 }}
                      >
                        {translatedCategory}
                      </span>
                      {isFourPointCategorie && (
                        <div className="icons">
                          <div className="color four_points_color"></div>
                        </div>
                      )}
                    </div>
                  </td>
                  {p?.data.map((c) => (
                    <td className="value_table" key={v1()}>
                      {c.value}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </article>
  );
};

export default CapPoints;
